import { createSlice } from "@reduxjs/toolkit";

const cacheSlice = createSlice({
  name: "cache",
  initialState: {
    apiResponses: {},
  },
  reducers: {
    // addToCache: (state, action) => {
    //   const { key, data, startDate, endDate } = action.payload;
    //   if (!state.apiResponses[key]) {
    //     state.apiResponses[key] = { data, startDate, endDate };
    //   }
    // },
    addToCache: (state, action) => {
      const { key, data, startDate, endDate } = action.payload;
      // Verificar si ya existen datos para esta clave
      if (state.apiResponses[key]) {
        // Asumiendo que los datos son arrays, combinar los existentes con los nuevos
        // Ajusta la lógica de combinación según la estructura de tus datos
        state.apiResponses[key].data = [...state.apiResponses[key].data, ...data];
        // Actualizar las fechas si es necesario
        state.apiResponses[key].startDate = startDate < state.apiResponses[key].startDate ? startDate : state.apiResponses[key].startDate;
        state.apiResponses[key].endDate = endDate > state.apiResponses[key].endDate ? endDate : state.apiResponses[key].endDate;
      } else {
        // Si no hay datos existentes, simplemente añadirlos
        state.apiResponses[key] = { data, startDate, endDate };
      }
    },
    removeFromCache: (state, action) => {
      delete state.apiResponses[action.payload.key];
    },
  },
});

export const { addToCache, removeFromCache } = cacheSlice.actions;

export default cacheSlice.reducer;
